import './my2050tool.less'

import {m, wrap} from '@codeurs/front'
import {ArrowIcon, ArrowLinkIcon} from 'assets/inline-icons'
import {Component} from 'react'
import {
	BlocksData,
	CardData,
	ImageType,
	LinkType,
	PageData,
	PaginationResult,
	WysiwygType
} from 'types'
import {style} from 'util/style'
import {Layout2050} from 'views/layout2050'
import {HeaderPortal} from 'views/partials/header'
import {Hero} from 'views/partials/hero'
import {Partners, PartnersData} from 'views/partials/partners'
import {Share} from 'views/partials/share'
import {Theme} from 'views/theme'
import {Blocks} from '../blocks/blocks'
import {PageShare} from './page'

const styles = style('my2050tool')

@wrap(Layout2050)
export class My2050Tool extends Component<{
	data: PageData &
		BlocksData & {
			articles: PaginationResult<CardData>
			featured: CardData
			newsletter: {
				title: string
				text: string
				placeholder: string
				agree: string
				thanks: string
			}
			page_title: string
			intro: WysiwygType
			quote_right: string
			image: ImageType
			text: WysiwygType
			quote_left: string
			partners?: PartnersData
			link?: LinkType
		}
}> {
	render() {
		const {page_title, partners, blocks, link, hero, url, id} = this.props.data
		return (
			<div class={styles}>
				<Theme.Container class={styles('container')}>
					<HeaderPortal>
						<Hero hero={!!(hero && hero.image)}>
							<Theme.H1>{page_title}</Theme.H1>
						</Hero>
					</HeaderPortal>
					<div className={styles('content')}>
						<Theme.Container>
							<div className={styles('content-toolbutton')}>
								{link && (
									<Theme.Button to={link.url}>
										<div className={styles('content-toolbutton-text')}>
											{link.description ? link.description : link.title}
											<ArrowLinkIcon
												className={styles('content-toolbutton-image')}
											/>
										</div>
									</Theme.Button>
								)}
								<div className={styles('content-sharepage')}>
									<PageShare copy={page_title} url={url} />
								</div>
							</div>
							{blocks && blocks.length > 0 && (
								<div class={styles('content-blocks')}>
									<Blocks blocks={blocks} pageId={id} wide={true} />
								</div>
							)}
							{partners && partners.length > 0 && (
								<div class={styles('content-partners')}>
									<Theme.H3>Partners My2050-tool</Theme.H3>
									<Partners partners={partners} />
								</div>
							)}
						</Theme.Container>
					</div>
				</Theme.Container>
			</div>
		)
	}
}
